import { CollectionsApiClient } from '@fourthwall/services/dist/CollectionsApiClient'
import { createQueryHook } from '@fourthwall/utils'
import { decodeHtmlEntities } from '@fourthwall/utils/dist/sanitize'

export const useCollectionOffers = createQueryHook(CollectionsApiClient.getCollectionOffers, {
  queryKey: ['collectionOffers'],
  select: (data) => {
    data.offers = data.offers.map((offer) => ({
      ...offer,
      name: decodeHtmlEntities(offer.name),
    }))

    return data
  },
})
